/* eslint-disable no-console */

import { index, IndexedDBBackend, Table } from "@bodil/bdb";
import type { Signal } from "@bodil/signal";

try {
    new Temporal.Instant(0n);
    console.debug("Browser supports Temporal.");
} catch (_e) {
    console.warn("Browser is missing Temporal! Loading polyfill.");
    /// @ts-ignore
    window.Temporal = (await import("temporal-polyfill")).Temporal;
    console.info("Temporal polyfill loaded:", window.Temporal);
}

export interface Program {
    id: string;
    title: string;
    ctime: Temporal.Instant;
    mtime: Temporal.Instant;
    code: string;
}

export interface Setting<T = unknown> {
    key: string;
    value: T;
}

const storage = await IndexedDBBackend.open({ name: "bc-backend", version: 1 });

const docsTable = Table.create<Program>()
    .withPrimaryIndex(index<Program>().key("id"))
    .withIndex(index<Program>().key("title"))
    .withIndex(index<Program>().time("ctime"))
    .withIndex(index<Program>().time("mtime"))
    .withStorage(storage, "docs");

export const docs = await docsTable.ready.then(() => docsTable);

const settingsTable = Table.create<Setting>()
    .withPrimaryIndex(index<Setting>().key("key"))
    .withStorage(storage, "settings");

export const settings = await settingsTable.ready.then(() => ({
    get<T>(key: string, defaultValue: T): Signal.Computed<T> {
        return settingsTable
            .signal(key)
            .map((setting) => setting?.value ?? defaultValue) as Signal.Computed<T>;
    },
    set<T>(key: string, value: T) {
        settingsTable.add({ key, value });
    },
}));

if (import.meta.env.DEV) {
    (window as any).settings = settings;
    (window as any).docs = docs;
}
